import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3jxtednxl5: FaireBrandEntity = {
  token: "b_3jxtednxl5",
  type: "brand",
  name: "OMG Accessories",
  avatarUrl:
    "https://cdn.faire.com/fastly/968e15fe047fa786cccf9c9a24153674374ac9f35e0fbbbfe88f3e1d2c41bb82.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0df3d3a9b773ae85fe486ee4b31c1d4d3eda1d0b516f40b991db44a6c82cda70.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/968e15fe047fa786cccf9c9a24153674374ac9f35e0fbbbfe88f3e1d2c41bb82.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0df3d3a9b773ae85fe486ee4b31c1d4d3eda1d0b516f40b991db44a6c82cda70.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 40,
  isTopShop: true,
  isInsider: true,
  description:
    "OMG Accessories is the iconic fashion brand behind millions of stylish kids and tweens around the world.\n\nWe’ve dreamed up a unique blend of big ideas, timeless inspiration, and sprinkled it with plenty of sparkle and shine, for the ultimate mini fashionista. Our whimsical designs and products are custom-made by our talented team, from each and every detail, to inventing our own fabrications and charm. \n\nAt OMG Accessories, everything looks better in glitter!  We’ve been the powerful, whimsical force behind innovation and design in fashion for more than a decade. With OMG Accessories, expect the unexpected! And, most of all, have fun!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:15.751Z",
    importedBy: "entity-db-cli",
  },
};
